module.exports = __webpack_public_path__ + "static/img/103022.5f8239ae.png";